export default "__VITE_ASSET__Ijmf3bzi__"